import { render } from "./MultiTextBox.vue?vue&type=template&id=2df8e933&scoped=true"
import script from "./MultiTextBox.vue?vue&type=script&lang=js"
export * from "./MultiTextBox.vue?vue&type=script&lang=js"

import "./MultiTextBox.vue?vue&type=style&index=0&id=2df8e933&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df8e933"]])

export default __exports__